import { render } from "./AllTickets.vue?vue&type=template&id=d89ba6a8&scoped=true&ts=true"
import script from "./AllTickets.vue?vue&type=script&lang=ts"
export * from "./AllTickets.vue?vue&type=script&lang=ts"

import "./AllTickets.vue?vue&type=style&index=0&id=d89ba6a8&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89ba6a8"]])

export default __exports__